// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__3KVnw","balanceDisclaimer":"posDashboard_balanceDisclaimer__2oZsH"};